export default __webpack_public_path__ + "static/media/swagger-svgrepo-com.136a841e.svg";